<template>
    <div :class="className">
        <VideoNative v-if="useSimpleStream" @onplay="onplay" v-bind="videoParams" />
        <VideoSafari v-else-if="isSafari" @onplay="onplay" @fullscreenexit="$emit('fullscreenexit')" v-bind="videoParams" ref="videoPlayer"/>
        <VideoPlayer v-else @onplay="onplay" @fullscreenexit="$emit('fullscreenexit')" v-bind="videoParams" ref="videoPlayer"/>
    </div>
</template>
<script>
import VideoNative from './Parts/VideoNative.vue';
import VideoSafari from './Parts/VideoSafari.vue';
import VideoPlayer from './Parts/VideoPlayer.vue';
import browser from "@/Utilities/browser";

export default {
    name: 'Video',
    components: {
        VideoNative,
        VideoSafari,
        VideoPlayer
    },
    props: {
        source: {
            type: String,
            required: true
        },
        poster: {
            type: String,
            default: null
        },
        forceNative: {
            type: Boolean,
            default: false
        },
        muted:{
            type: Boolean,
            default: true
        },
        showplay: {
            type: Boolean,
            default: false
        },
        autoplay: {
            type: Boolean,
            default: true
        },
        className: {
            type: String,
            default: 'w-100'
        },
        loop:{
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showSpinnerLoader: false
        }
    },
    computed: {
        videoParams(){
            return {
                source: this.source,
                autoplay: this.autoplay,
                muted: this.muted,
                loop: this.loop,
                showplay: this.showplay
            }
        },
        useSimpleStream() {
            return this.isSafari && this.forceNative;
        },
        isSafari() {
            return browser.isSafari() || browser.isIOS();
        },
        isAppAndroid() {
            return browser.isApp() && !browser.isIOS();
        }
    },
    methods: {
        onplay(player = null){
            this.$emit('onplay', player);
        }
    }
};
</script>